function promo() {
    const promo = document.querySelectorAll('body > .promo');

    if( promo.length > 0 ) {
        promo.forEach( element => {
            // console.log({element});
            let trigger = element.querySelector('[data-promo-trigger]');
            // console.log({trigger});

            trigger.addEventListener('click', (event) => {
                let current = element.getAttribute('data-open');

                if( current == 1 ) {
                    element.setAttribute('data-open', 0);
                } else {
                    element.setAttribute('data-open', 1); 
                }
                               
            });

            if( document.querySelector('body.home') ) {
                setTimeout( function() {
                    element.setAttribute('data-open', 1);
                }, 15000);
            }
        });
    }
}

promo();